import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateSavedView() {
  const queryClient = useQueryClient()

  const action = async ({ surface, name, config, is_default }) => {
    const response = await httpClient.post('team/saved-views', {
      surface,
      name,
      config,
      is_default,
    })
    return response.data
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: () => {
      toast.success('View saved.')
      queryClient.invalidateQueries({ queryKey: ['saved-views'] })
    },
    onError: (error) => {
      const message =
        error?.response?.data?.errors?.name?.[0] ??
        error?.response?.data?.message ??
        "Couldn't save the view."
      toast.error(message)
    },
  })

  return { action: mutation.mutateAsync, status: mutation }
}
